export const UPDATE_TAB = tab => ({ type: 'SET_SELECTED_TAB', payload: tab })